export enum VictorySceneResult {
    NextLevel = "NextLevel",
    Home = "Home"
}
